module.exports = __webpack_public_path__ + "media/images/btn_add_note-b9fdf1bef2efa1db678ef4d076d0a266.gif";